import { css, SerializedStyles } from '@emotion/core';
import { Theme, helpText, normalText, titleText } from 'features/Theme';

const styles = {
  titleText: (theme: Theme): SerializedStyles => css`
    ${normalText(theme)}
    text-align: center;
    font-weight: ${theme.mui.typography.fontWeightBold};
    margin-bottom: ${theme.mui.spacing(3)}px;
  `,
  widgetContainer: (theme: Theme): SerializedStyles => css`
    width: 100%;
    margin-bottom: ${theme.mui.spacing(1)}px;
    background: none;
    border: none;
    text-align: start;
    cursor: pointer;
  `,
  widget: css`
    width: 100%;
  `,
  cardName: (theme: Theme): SerializedStyles => css`
    ${normalText(theme)}
  `,
  creditLimit: (theme: Theme): SerializedStyles => css`
    ${titleText(theme)}
  `,
  availableCredit: (theme: Theme): SerializedStyles => css`
    ${helpText(theme)}
  `,
};

export default styles;
